module.exports = __webpack_public_path__ + "static/img/5.640c984.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/5.png
// module id = KF66
// module chunks = 0